import React from "react";
import {Col} from "antd";
import {CourierFilter, SearchText} from "../../../../_defaultComponents/FilterComponents";

export const TerminalHistoryTabFilters = ({filters, setFilters}) => {
    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SearchText
                    value={filters.serialNo}
                    onChange={value => setFilters({...filters, serialNo: value})}
                    label="Serial No"
                    showLabel={true}
                />
            </Col>
        </React.Fragment>
    );
};
